
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';
import {
  ConsoleActionAvailability,
  listAvailableActions,
} from './actions';
import { ConsoleSiteContext } from './types';

@Component({
  components: { StatusChip },
})
export default class ConsoleInspector extends Vue {
  @Prop({ type: Object, default: null })
  public context!: ConsoleSiteContext | null;

  @Prop({ type: Object, default: null })
  public composite!: WebsiteComposite | null;

  @Prop({ type: Array, default: () => [] })
  public scopes!: string[];

  @Prop({ type: Boolean, default: false })
  public loading!: boolean;

  @Prop({ type: Boolean, default: false })
  public mobileOpen!: boolean;

  public get availableActions(): ConsoleActionAvailability[] {
    return listAvailableActions(this.composite, this.scopes || [])
      .filter((item) => item.available)
      .slice(0, 12);
  }

  public get details() {
    return this.composite ? this.composite.details : null;
  }

  public get website() {
    return this.composite ? this.composite.website : null;
  }

  public get ownerLabel(): string {
    if (this.website && this.website.userId) {
      return this.website.userId;
    }
    if (this.composite && this.composite.group && this.composite.group.owner) {
      return this.composite.group.owner;
    }
    return '—';
  }

  public get dbCount(): string | number {
    if (!this.details || !this.details.databaseIds) {
      return '—';
    }
    return this.details.databaseIds.length;
  }

  public closeMobile(): void {
    this.$emit('update:mobileOpen', false);
  }
}
